import { CustomModal } from 'components'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getVideoSummaryAction } from 'store/action/videoReducer'

function VideoSummaryModal({ videoSummaryModal, onClose }) {
   const videoRedux = useSelector((state) => state.videoRedux)
   const { videoSummaryLoading, videoDetails, videoSummary } = videoRedux
   const dispatch = useDispatch()
   const settingData = useSelector((state) => state.settings)
   const { selectedChannelID } = settingData

   useEffect(() => {
      if (videoDetails && videoSummary === '' && !videoSummaryLoading) {
         dispatch(
            getVideoSummaryAction({
               channel_id: selectedChannelID,
               video_id: videoDetails?.video_id
            })
         )
      }
      return () => {}
   }, [videoDetails])

   return (
      <div>
         <CustomModal
            show={videoSummaryModal}
            title={'Video Summary'}
            closeModal={onClose}
            centered
            size="lg"
            scrollable>
            {videoSummaryLoading ? (
               <div className="card_sk">
                  <div className="card__title loading"></div>
                  <div className="card__title loading"></div>
                  <div className="card__title loading"></div>
               </div>
            ) : videoSummary ? (
               Object.entries(videoSummary).map(([key, value]) => {
                  return (
                     <div className="at-text-light mt-2" key={key}>
                        <label className="at-text-dark">{key}</label> <p>{value}</p>
                     </div>
                  )
               })
            ) : (
               <div className="at-text-light mt-2">
                  <span className="at-text-dark">{videoDetails?.content_summary}</span>
               </div>
            )}
         </CustomModal>
      </div>
   )
}

export default VideoSummaryModal
